
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('core/buffer_core_imagedata',["require", "exports", './buffer_core'], function(require, exports, buffer_core) {
    

    /**
    * Implementation of BufferCore that is backed by an ImageData object.
    * Useful in browsers with HTML5 canvas support, but no TypedArray support
    * (IE9).
    */
    var BufferCoreImageData = (function (_super) {
        __extends(BufferCoreImageData, _super);
        function BufferCoreImageData(length) {
            _super.call(this);
            this.length = length;
            this.buff = BufferCoreImageData.getCanvasPixelArray(length);
        }
        /**
        * Constructs a CanvasPixelArray that represents the given amount of bytes.
        */
        BufferCoreImageData.getCanvasPixelArray = function (bytes) {
            var ctx = BufferCoreImageData.imageDataFactory;

            // Lazily initialize, otherwise every browser (even those that will never
            // use this code) will create a canvas on script load.
            if (ctx === undefined) {
                BufferCoreImageData.imageDataFactory = ctx = document.createElement('canvas').getContext('2d');
            }

            // You cannot create image data with size 0, so up it to size 1.
            if (bytes === 0)
                bytes = 1;
            return ctx.createImageData(Math.ceil(bytes / 4), 1).data;
        };
        BufferCoreImageData.isAvailable = function () {
            // Modern browsers have removed this deprecated API, so it is not always around.
            return typeof CanvasPixelArray !== 'undefined';
        };

        BufferCoreImageData.prototype.getLength = function () {
            return this.length;
        };
        BufferCoreImageData.prototype.writeUInt8 = function (i, data) {
            this.buff[i] = data;
        };
        BufferCoreImageData.prototype.readUInt8 = function (i) {
            return this.buff[i];
        };
        BufferCoreImageData.prototype.copy = function (start, end) {
            // AFAIK, there's no efficient way to clone ImageData.
            var newBC = new BufferCoreImageData(end - start);
            for (var i = start; i < end; i++) {
                newBC.writeUInt8(i - start, this.buff[i]);
            }
            return newBC;
        };
        return BufferCoreImageData;
    })(buffer_core.BufferCoreCommon);
    exports.BufferCoreImageData = BufferCoreImageData;

    // Type-check the class.
    var _ = BufferCoreImageData;
});
//# sourceMappingURL=buffer_core_imagedata.js.map
;